import styled from 'styled-components';

export const WrapperForm = styled.div`
    display: flex; 
    width: 100%;
`;


export const WrapperUpload = styled.div`
  display: flex;
  flex-direction: column;
  .section-input{
    flex-direction: column;
    .input-file{
      margin: 20px
    }
    .button-upload{
      width: 100%;
    }
  }
`;

export const WrapperSearch = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
`
export const WrapperTabs = styled.div`
  display: flex;

  .section-button {
    display: flex;
    justify-content: end;
  }
`;

export const SectionCheckBox = styled.div`
  display: flex;
  justify-content: left;
  margin: 50px;
`;

export const SectionPanel = styled.div`
  .section-tab {
    height: 350px;
    overflow-y: scroll;
  }
`